import * as types from "./types";
import * as AppActionTypes from "../../../../store/app/types";
import router from '../../../../router';
export const reportsDistributionActions = {
    async [types.SET_DISTRIBUTION_REPORT_NAB_ITEMS]({ commit, rootState }, tabs) {
        console.log('rootState', rootState.app)
        console.log('tabs', tabs)
        commit(
            AppActionTypes.SET_APP_NAV_ITEMS,
            rootState.app.appNavItems.map((module) => {
                if (module.route == "distribution") {
                    return {
                        ...module,
                        children: module.children.map((sub) => {
                            if (sub.route == "reports") {
                                return {
                                    ...sub,
                                    children: [...tabs],
                                };
                            } else {
                                return sub;
                            }
                        }),
                    };
                } else {
                    return module;
                }
            }),
            { root: true }
        );
        console.log('rootState', rootState)
    },


};


